// extracted by mini-css-extract-plugin
export default {"sec-title":"Layout_sec-title__+Grs6","flexlayout":"Layout_flexlayout__NotYO"};